import type { CSSProperties } from 'react';

// Ilustraciones oficiales del colegio. Decorativas: alt="" + aria-hidden
// (handoff §10). <picture> sirve WebP optimizado con fallback a PNG.
const CHAPTER_IMG: Record<string, string> = {
  facade: 'portada',
  family: 'preescolar',
  flag: 'equipo',
  books: 'aprendizaje',
  bus: 'canchas',
  community: 'comunidad',
  sun: 'campus',
};

const fill: CSSProperties = {
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

export function ChapterArt({ kind, eager }: { kind: string; eager?: boolean }) {
  const base = CHAPTER_IMG[kind];
  if (!base) return null;
  return (
    <picture style={fill}>
      <source srcSet={`/img/${base}.webp`} type="image/webp" />
      <img
        src={`/img/${base}.png`}
        alt=""
        aria-hidden="true"
        draggable={false}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        style={fill}
      />
    </picture>
  );
}
